import React, { FC, useEffect, useState } from "react";
import { Button, Input, Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { PatientListRow } from "../patientListTabConfig";
import "../PatientListModal.css";
import "./AuthorityPatientList.css";

export type NmiQueryActionType = "accept" | "close" | "requery";

type NmiQueryActionModalProps = {
  open: boolean;
  type: NmiQueryActionType | null;
  patient: PatientListRow | null;
  loading?: boolean;
  onClose: () => void;
  onConfirm: (payload: {
    type: NmiQueryActionType;
    patient: PatientListRow;
    remarks: string;
  }) => void | Promise<void>;
};

const titles: Record<NmiQueryActionType, string> = {
  accept: "Accept Response",
  close: "Close Query",
  requery: "Requery",
};

const NmiQueryActionModal: FC<NmiQueryActionModalProps> = ({
  open,
  type,
  patient,
  loading = false,
  onClose,
  onConfirm,
}) => {
  const [remarks, setRemarks] = useState("");

  useEffect(() => {
    if (open) setRemarks("");
  }, [open, type, patient?.queryId]);

  if (!type) return null;

  const patientName = patient?.fullName || patient?.patientName || "—";
  const requiresRemarks = type === "close" || type === "requery";

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      width={480}
      className="pl-modal apl-decision-modal"
      destroyOnClose
      centered
      styles={{ body: { padding: 0 } }}
    >
      <div className="pl-modal-shell">
        <div className="hpl-accept-modal-header">
          <h2 className={`hpl-accept-modal-title apl-modal-title apl-modal-title--${type}`}>
            {titles[type]}
          </h2>
          <button type="button" className="hpl-accept-modal-close" onClick={onClose} aria-label="Close">
            <CloseOutlined />
          </button>
        </div>
        <div className="pl-modal-scroll-body apl-decision-body">
          <div className="apl-decision-field">
            <span className="apl-decision-label">Patient Name</span>
            <Input value={patientName} disabled />
          </div>
          <div className="apl-decision-field">
            <span className="apl-decision-label">Remarks</span>
            <Input.TextArea
              rows={4}
              placeholder="Enter"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
            />
          </div>
        </div>
        <div className="hpl-accept-modal-footer">
          <Button onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            type="primary"
            className={`apl-decision-submit apl-decision-submit--${type}`}
            loading={loading}
            disabled={requiresRemarks && !remarks.trim()}
            onClick={() =>
              patient &&
              onConfirm({
                type,
                patient,
                remarks: remarks.trim(),
              })
            }
          >
            {titles[type]}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default NmiQueryActionModal;
